import { Card, Grid, Typography } from "@mui/material";
import Label from "src/components/Label";

import CardHeader from "./CardHeader";

// ----------------------------------------------------------------------

export const ScopesCard = () => {
	return (
		<Card sx={{ maxWidth: 1100, pb: 3, p: 3 }}>
			<CardHeader />
			<Grid container spacing={1} sx={{ mt: 2 }}>
				<Grid item>
					<Label color='primary'>
						<Typography fontSize={12}>{"read"}</Typography>
					</Label>
				</Grid>
				<Grid item>
					<Label color='primary'>
						<Typography fontSize={12}>{"write"}</Typography>
					</Label>
				</Grid>
				<Grid item>
					<Label color='primary'>
						<Typography fontSize={12}>{"delete"}</Typography>
					</Label>
				</Grid>
			</Grid>
		</Card>
	);
};

export default ScopesCard;
